<template>
  <div class="result__options-sort">
    <select
      ref="select"
      name="options-sort"
      class="select2 select2WithoutSearch"
      id="cruise-sort-select"
    >
      <option value="date_from" data-reverse="false">
        По дате отправления
      </option>
      <option value="date_from" data-reverse="true">По дате отправления</option>
      <option value="min_price" data-reverse="false">По цене</option>
      <option value="min_price" data-reverse="true">По цене</option>
      <option value="discount" data-reverse="false">По скидке</option>
      <option value="discount" data-reverse="true">По скидке</option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
import "select2";

export default {
  name: "CruiseListSort.vue",
  computed: {
    ...mapGetters(["sort", "items"]),
  },
  inheritAttrs: false,
  methods: {
    formatState: function (state) {
      if (!state.id) {
        return state.text;
      }
      let baseUrl = "/local/mosturflot-frontend/src/assets/img/search-cruise";
      let $state = $(
        '<span class="d-flex align-items-center"><img class="img-flag" /> <span></span></span>'
      );
      // Use .text() instead of HTML string concatenation to avoid script injection issues
      $state.find("span").text(state.text);
      let file = $(state.element).data("reverse") ? "sort-desc" : "sort-asc";
      $state.find("img").attr("src", baseUrl + "/" + file + ".png");
      return $state;
    },
  },
  mounted: function () {
    $("#cruise-sort-select")
      .select2({
        placeholder: $(this).data("placeholder"),
        minimumResultsForSearch: Infinity,
        language: {
          noResults: function () {
            return "Не найдено";
          },
        },
        escapeMarkup: function (m) {
          return m;
        },
        dropdownPosition: "below",
        templateSelection: this.formatState,
        templateResult: this.formatState,
        dropdownCssClass: "river__sorting-dropdown",
      })
      .on("select2:select", (e) => {
        e.currentTarget.dispatchEvent(new Event("change"));
        var selectId = e.target.id;
        $(".search-cruise-select__label[for='" + selectId + "']").addClass(
          "active"
        );
        let option = $(e.target).find("option:selected");
        this.$store.dispatch("setSort", {
          key: option.val(),
          reverse: option.data("reverse"),
        });
      })
      .on("select2:open", (e) => {
        var selectId = e.target.id;
        $(
          ".select2-search__field[aria-controls='select2-" +
            selectId +
            "-results']"
        ).each(function (key, value) {
          value.focus();
        });
        $(".search-cruise-select__label[for='" + selectId + "']").addClass(
          "active"
        );
      })
      .on("select2:close", (e) => {
        var selectId = e.target.id;
        if ($("#" + selectId).val() === "") {
          $(".search-cruise-select__label[for='" + selectId + "']").removeClass(
            "active"
          );
        }
      });
  },
};
</script>
